<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-player-skip-back" width="20" height="20" viewBox="3 3 20 20" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <path d="M20 5v14l-12 -7z" />
    <line x1="4" y1="5" x2="4" y2="19" />
  </svg>
</template>
  
<script>
  export default {}
</script>
  
<style>
 
</style>